import { render, staticRenderFns } from "./ImportProspectsModal.vue?vue&type=template&id=0539c5f6&scoped=true&"
import script from "./ImportProspectsModal.vue?vue&type=script&lang=ts&"
export * from "./ImportProspectsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ImportProspectsModal.vue?vue&type=style&index=0&id=0539c5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539c5f6",
  null
  
)

export default component.exports